import React from 'react'
import PropTypes from 'prop-types'
import Card from 'react-bootstrap/esm/Card'
import {CardBody} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faShirt, faSquare } from '@fortawesome/free-solid-svg-icons'
import {translateColor, splitTeams, withoutDate, keepHyphens} from '../match'


class ActivityEntry extends React.Component	
{
	constructor(props)
	{
		super(props)
		this.state = { }
	}
	translateWeekday(weekday)
	{
		const map = {
			monday: 'Mandag',
			tuesday: 'Tirsdag',
			wednesday: 'Onsdag',
			thursday: 'Torsdag',
			friday: 'Fredag',
			saturday: 'Lørdag',
			sunday: 'Søndag',
		}

		return map[weekday]
	}
	translatePlace(type)
	{
		const map = {
			'sundthus': 'SundtHus',
			'jysk':	'Jysk',
			'jjd':	'JJD',
			'ojm':	'O. Jacobsen Maskinfabrik',
			'bms':	'BM Silo',
			'vb':	'Vestjysk Bank',
			'dom': 'Dameomklædning i kælderen',
			'hom': 'Herreomklædning i kælderen',
		}
		return map[type]
	}

	translateColor(color)
	{
		return translateColor(color)
	}

	splitTeams(entry)
	{
		return splitTeams(entry)
	}

	withoutDate(name)
	{
		return withoutDate(name)
	}

	keepHyphens(name)
	{
		return keepHyphens(name)
	}

	render()
	{
		let leftShirt = ''
		let rightShirt = ''
		const entry = this.props.json
		const date = new Date
		const from = parseInt(entry.timeFrom.replace(':', ''))
		const too = parseInt(entry.timeToo.replace(':', ''))
		const current_time = parseInt(date.getHours()+''+date.getMinutes().toString().padStart(2, '0'))
		if (entry.type === '3')
		{
			entry.eventName = entry.eventName + ' i ' + this.translatePlace(entry.eventPlace)
		}

		if (entry.leftShirt !== undefined)
		{
			let shirtColor = this.translateColor(entry.leftShirt.ShirtColor)
			let shortsColor = this.translateColor(entry.leftShirt.ShortsColor) ?? shirtColor

			leftShirt = (<span className="fa-stack" style={{verticalAlign: 'top'}}>
				<FontAwesomeIcon
					className='fa-stack-2x'
					icon={faSquare}
					style={{
						color: 'var(--bs-body-bg)',
					}}
				/>
				<FontAwesomeIcon
					className='fa-stack-1x'
					icon={faShirt}
					style={{
						color: shirtColor,
						clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)', // whole shirt
					}}
				/>
				<FontAwesomeIcon
					className='fa-stack-1x'
					icon={faShirt}
					style={{
						color: shortsColor,
						clipPath: 'polygon(100% 0, 100% 100%, 0% 100%)', // shorts colour in the bottom-right corner
					}}
				/>
			</span>)
		}
		if (entry.rightShirt !== undefined)
		{
			let shirtColor = this.translateColor(entry.rightShirt.ShirtColor)
			let shortsColor = this.translateColor(entry.rightShirt.ShortsColor) ?? shirtColor
			rightShirt = (<span className="fa-stack" style={{verticalAlign: 'top'}}>
				<FontAwesomeIcon
					className='fa-stack-2x'
					icon={faSquare}
					style={{
						color: 'var(--bs-body-bg)',
					}}
				/>
				<FontAwesomeIcon
					className='fa-stack-1x'
					icon={faShirt}
					style={{
						color: shirtColor,
						clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)', // whole shirt
					}}
				/>
				<FontAwesomeIcon
					className='fa-stack-1x'
					icon={faShirt}
					style={{
						color: shortsColor,
						clipPath: 'polygon(100% 0, 100% 100%, 0% 100%)', // shorts colour in the bottom-right corner
					}}
				/>
			</span>)
		}

		const teams = this.splitTeams(entry)
		const running = from <= current_time && too >= current_time
		const subEventName = teams ? this.withoutDate(entry.subEventName) : entry.subEventName

		return (
			<Card className={(running ?  'active' : 'border-secondary') + ' entry'}>
				<CardBody>
					{teams ? (
						// Scoreboard: the start time sits above the VS, the class under the teams.
						<div className="name-part">
							<div className="versus">
								<div className="versus-home"><span className="versus-shirt">{leftShirt}</span><span>{this.keepHyphens(teams[0])}</span></div>
								<div className="versus-mid">
									<div className={'versus-time' + (running ? ' running' : '')}>{entry.timeFrom}</div>
									<div className="versus-vs">VS</div>
								</div>
								<div className="versus-away"><span>{this.keepHyphens(teams[1])}</span><span className="versus-shirt">{rightShirt}</span></div>
							</div>
							{subEventName && <div className="versus-sub">{subEventName}</div>}
						</div>
					) : (
						<div className="name-part">
							<h3 className="m-0 p-0 mb-2"><span className={'versus-time' + (running ? ' running' : '')}>{entry.timeFrom}</span> <span className="versus-sub">{subEventName}</span></h3>
							<span style={{fontSize: '35px'}}>{leftShirt}</span>{entry.eventName}<span style={{fontSize: '35px'}}>{rightShirt}</span>
						</div>
					)}

				</CardBody>
			</Card>
		)
	}
}

ActivityEntry.propTypes = {
	json: PropTypes.object,
	first: PropTypes.bool,
}

export default ActivityEntry
